// src/components/AdminPage.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Announcement from "./Announcement";
import Banner from "./Banner";
import MenuItems from "./MenuItems";
import StoreHours from "./StoreHours";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";

import './AdminPage.css';

const businessId = "6709f0331882028713f23319";

const AdminPage = () => {
  const navigate = useNavigate();
  const isAdminLoggedIn = localStorage.getItem("admin");

  useEffect(() => {
    if (!isAdminLoggedIn) {
      navigate("/admin-login");
    }
  }, [isAdminLoggedIn, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("admin");
    navigate("/");
  };

  return (
    <div className="admin-container">
      {isAdminLoggedIn && (
        <button className="logout-icon" onClick={handleLogout} title="Logout">
          <FontAwesomeIcon icon={faPowerOff} />
        </button>
      )}

      <h1 className="admin-container_title" >Admin Dashboard</h1>
      <Announcement />
      <Banner />
      <StoreHours businessId={businessId} />
      <MenuItems />
    </div>
  );
};

export default AdminPage;
